import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 06.2da9da11c5c4ca6c3082.jpg`;
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 07.d9e7b23f4e843a749067.jpg`;
const Factory3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 08.7f06886cba736589a172.jpg`;
const Item1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/한국지게차.e1d936cf245155298ab9.png`;
const ForkHeadOffice8 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">Fork Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">지역별법인</div>
                <div className="eng">Corporation by region</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"830px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOffice8">
                <div className="kor">한국 법인 (부천)</div>
                <div className="eng">Korea HQ (Bucheon)</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">클라크 미국본사</div>
                  <div className="eng">USA HQ</div>
                </Link>
              </S.NavItem>
<S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeMexico">
                  <div className="kor">멕시코 법인</div>
                  <div className="eng">Mexico Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice2">
                  <div className="kor">브라질 법인</div>
                  <div className="eng">Brasil Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice3">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa-Rica Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice4">
                  <div className="kor">독일 법인</div>
                  <div className="eng">Germany Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice5">
                  <div className="kor">프랑스 법인</div>
                  <div className="eng">France Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice6">
                  <div className="kor">호주 법인</div>
                  <div className="eng">Australia Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice7">
                  <div className="kor">싱가폴 법인</div>
                  <div className="eng">Singapore Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                              <Link to="/ForkLiftBusiness/HeadOfficeVnHq">
                                <div className="kor">베트남 판매법인</div>
                                <div className="eng">Vietnam Sales Company</div>
                              </Link>
                            </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice8">
                  <div className="kor">한국 법인 (부천)</div>
                  <div className="eng">Korea HQ (Bucheon)</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice9">
                  <div className="kor">베트남 1공장</div>
                  <div className="eng">Vietnam Company1</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice10">
                  <div className="kor">베트남 2공장</div>
                  <div className="eng">Vietnam Company2</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice11">
                  <div className="kor">중국법인</div>
                  <div className="eng">China Company</div>
                </Link>
              </S.NavItem>
               <S.NavItem className="list-inner-item">
                                                                                                    <Link to="/ForkLiftBusiness/HeadOfficeIdnesia">
                                                                                                      <div className="kor">인도네시아 법인</div>
                                                                                                      <div className="eng">Indonesia Company</div>
                                                                                                    </Link>
                                                                                                  </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice12">
                  <div className="kor">한국 법인 (창원)</div>
                  <div className="eng">Korea Company (Changwon) </div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                                                    <Link to="/ForkLiftBusiness/HeadOfficeRnd">
                                                                                                      <div className="kor">글로벌 연구소</div>
                                                                                                      <div className="eng">Global R&D Center</div>
                                                                                                    </Link>
                                                                                                  </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"한국 법인 (부천)"}
              titleeng={"CLARK Korea HQ (Bucheon) "}
              website={"http://www.clarkmhc.co.kr/"}
            />
            <div className="page-text">
              <h2>CLARK Material Handling International / CMHI</h2>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">한국 법인</div>
                <div className="eng">CLARK Material Handling International / CMHI</div>
              </div>
            </S.ImgHolderFullsize>
            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">지게차 전시장</div>
                  <div className="eng">Clark Showroom</div>
                </div>
              </S.ImgHolderHarf>
              <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">지게차 역사관</div>
                  <div className="eng">Clark History Hall</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <S.ImgHolderFlex className="start">
              <div>
                <PageTitle titleko={"주요 판매 제품"} titleeng={"Major Sales Products"} />

                <img src={Item1} className="img-item-plus" alt="" />
              </div>
              <div>
                <PageTitle titleko={"주요 이력"} titleeng={"Major History"} />
                <div className="page-text"  style={{padding: 0 + 'em'}}>
                  <div className="page-text-flex">
                    <div className="page-text-area">
                      <div className="page-text-title">
                        <div className="kor">CLARK Material Handling International 법인개요</div>
                        <div className="eng">Company Profile of CLARK Material Handling International</div>
                      </div>
                      <div className="kor">
                        한국법인 설립: 1993년 <br />
                        클라크 사업 시작: 2004년
                      </div>
                      <div className="eng">
                        <br />
                        Establishment in Korea : 1993 <br />
                        Start CLARK business : 2004
                      </div>
                    </div>
                  </div>
                  <div className="kor">
                    ※ CMHI는 클라크 지주회사 및 아시아 본부 업무 역할 수행
                    <br />※ 생산법인 관리 및 글로벌 지원 역할 진행
                  </div>
                  <div className="eng">
                    ※ Operate as CLARK Holding company and Asia HQ <br />
                    ※ Manage manufacturing affiliates and support <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;Global affiliates
                  </div>
                </div>
              </div>
            </S.ImgHolderFlex>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ForkHeadOffice8;
